import React from 'react';
import P from 'prop-types';
import { Button } from '../Button';
import { FormataValor } from '../../utils/utils';

export const FinalizacaoRodape = ({ onClick, isPagOnline, valor, isCompleted, text = '', disabled = true }) => {
  const css = isPagOnline ? ' btnPaymentGreen ' : ' btnFinalizar ';
  const _text = text ? text : isPagOnline ? 'Pagar' : 'Fazer Pedido';

  return (
    <div className="container padTop20 padBottom20">
      <Button
        disabled={disabled}
        //type={isPagOnline ? 'submit' : 'button'}
        onClick={onClick}
        className={`btn_1 full-width mb_5  ${css} ${!isCompleted && !isPagOnline ? ' btnDisabled' : ''}`}
        text={`${_text}`}
        textAlign={`${isPagOnline ? 'left' : 'center'}`}
        text2={`${isPagOnline ? FormataValor(valor) : ''}`}
        text2Align={`${isPagOnline ? 'right' : ''}`}
      />
    </div>
  );
};

FinalizacaoRodape.propTypes = {
  onClick: P.func,
  isPagOnline: P.oneOfType([P.bool, P.number]),
  isCompleted: P.bool,
  valor: P.oneOfType([P.string, P.number]),
  text: P.string,
  disabled: P.bool,
};
